import { PendingSsnItem } from '../../../application/domain/entities/PendingSsnItem';
import { PendingSsnItemDto } from '../dto/PendingSsnItemDto';

export const pendingSsnItemMapper = {
  toDomain: (dto: PendingSsnItemDto): PendingSsnItem => ({
    i9FormId: dto.i9FormId,
    firstName: dto.firstName,
    lastName: dto.lastName,
    middleName: dto.middleName ?? undefined,
    email: dto.email,
    hireDate: dto.hireDate ? new Date(dto.hireDate) : undefined,
    doNotHaveSsnOption: dto.doNotHaveSsnOption,
    canArchive: dto.canArchive ?? false,
  }),
};
